var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_240_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_241_",
    d: "M10.2,8.9h10.6c0.2,0,0.4-0.2,0.4-0.4V7.7c0-0.2-0.2-0.4-0.4-0.4H10.2c-0.2,0-0.4,0.2-0.4,0.4v0.8 C9.8,8.8,9.9,8.9,10.2,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_251_",
    d: "M10.2,13.8h10.6c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H10.2c-0.2,0-0.4,0.2-0.4,0.4v0.8 C9.8,13.6,9.9,13.8,10.2,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_252_",
    d: "M10.2,18.7h10.6c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H10.2c-0.2,0-0.4,0.2-0.4,0.4v0.8 C9.8,18.5,9.9,18.7,10.2,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_256_",
    d: "M3.7,8.9h3.2c0.2,0,0.4-0.2,0.4-0.4V7.7c0-0.2-0.2-0.4-0.4-0.4H3.7c-0.2,0-0.4,0.2-0.4,0.4v0.8 C3.2,8.8,3.4,8.9,3.7,8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_257_",
    d: "M3.7,13.8h3.2c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H3.7c-0.2,0-0.4,0.2-0.4,0.4v0.8 C3.2,13.6,3.4,13.8,3.7,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_258_",
    d: "M3.7,18.7h3.2c0.2,0,0.4-0.2,0.4-0.4v-0.8c0-0.2-0.2-0.4-0.4-0.4H3.7c-0.2,0-0.4,0.2-0.4,0.4v0.8 C3.2,18.5,3.4,18.7,3.7,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_261_",
    d: "M24.4,0H1.6C0.7,0,0,0.7,0,1.6v22.8C0,25.3,0.7,26,1.6,26h22.8c0.9,0,1.6-0.7,1.6-1.6V1.6 C26,0.7,25.3,0,24.4,0z M24.4,24.4H1.6V1.6h22.8V24.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListbox);
export default __webpack_public_path__ + "static/media/Listbox.51d7e64c2993749b7911c52f08131203.svg";
export { ForwardRef as ReactComponent };